import { Box } from '@mui/material';
import { HtmlViewer } from './htmlViewer';
import { Linear } from '../../components/progressBars/linear';

interface HtmlViewerContainerProps {
  content: string;
  isLoading?: boolean;
}
export function HtmlViewerContainer({ content, isLoading }: HtmlViewerContainerProps) {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: '15px',
        minHeight: '600px',
        p: { xs: 0, md: '5px' },
      }}
    >
      {isLoading && <Linear />}
      {content && <HtmlViewer content={content} />}
    </Box>
  );
}
